import { Size } from '@ps/web-core-enums';
import type { TrackedTranslation } from '@ps/web-shared-components';
import { StarsButton, useScreenSize } from '@ps/web-shared-components';
import classNames from 'clsx';
import type { ButtonHTMLAttributes } from 'react';
import React, { useContext } from 'react';

import ButtonGroup from '@swf/components/ButtonGroup/ButtonGroup';
import { useIsMobileDevice, useWizardNav } from '@swf/poker';

import CreateTournamentContext from '../../CreateTournament/CreateTournamentContext/CreateTournamentContext';
import { ModalPagesRoutes } from '../../CreateTournament/utils/common';
import BackIcon from '../../assets/back.svg';
import HeaderBackIcon from '../assets/arrow-left.svg';

import { TXTCLI_Back } from './Buttons.messages.json';
import styles from './Buttons.scss';

export interface Props {
  className?: string;
  disabled: boolean;
  translation: TrackedTranslation;
  hideBackButton?: boolean;
  isSubmit?: boolean;
}

const Buttons = ({
  className,
  disabled,
  translation,
  hideBackButton = true,
  isSubmit = true
}: Props) => {
  const isMobile = useIsMobileDevice(true);

  const { greaterThan } = useScreenSize();
  const {
    state: { activePage },
    setState
  } = useContext(CreateTournamentContext);

  const goTo = useWizardNav(activePage);

  const handleGoBack = () => {
    setState((prevState) => ({ ...prevState, error: undefined }));
    goTo(activePage - 1, ModalPagesRoutes[activePage - 1]);
  };

  const handleNext = () => {
    setState((prevState) => ({ ...prevState, error: undefined }));
    goTo(activePage + 1, ModalPagesRoutes[activePage + 1]);
  };

  const submitProps = isSubmit
    ? { type: 'submit' as ButtonHTMLAttributes<HTMLButtonElement>['type'] }
    : { onClick: handleNext };

  return (
    <ButtonGroup
      className={classNames(styles.buttons, className, {
        [styles.mobile]: isMobile
      })}
    >
      <div className={styles.backNext}>
        {!hideBackButton && (
          <div className={styles.back}>
            <StarsButton
              variant="text"
              icon={<BackIcon />}
              translation={TXTCLI_Back}
              onClick={handleGoBack}
            />
          </div>
        )}
        {!hideBackButton && !greaterThan(Size.Small) && (
          <div className={styles.headerBack}>
            <StarsButton variant="text" icon={<HeaderBackIcon />} onClick={handleGoBack} />
          </div>
        )}
        <div className={styles.next}>
          <StarsButton
            id="createGameSubmit"
            translation={translation}
            disabled={disabled}
            {...submitProps}
          />
        </div>
      </div>
    </ButtonGroup>
  );
};

export default Buttons;
